import { useQuery } from "@apollo/client/react";
import { useMemo } from "react";
import invariant from "ts-invariant";

import { getFragmentData } from "@/generated/graphql";
import { CategoryEnum, GetUserCategoriesDocument, UserCategoryFragmentDoc } from "@/generated/graphql/graphql";

export function useUserCategory(categoryKey: CategoryEnum) {
  const { data } = useQuery(GetUserCategoriesDocument, { fetchPolicy: "cache-only" });
  return useMemo(() => {
    const userCategories = getFragmentData(UserCategoryFragmentDoc, data?.userCategories || []);

    if (userCategories.length > 0) {
      const userCategory = userCategories.find((category) => category.categoryKey === categoryKey);
      invariant(userCategory, `Category ${categoryKey} not found`);
      return userCategory;
    }

    return null;
  }, [categoryKey, data?.userCategories]);
}
